import type { DashboardStatsDto } from '../../domain/contracts/api.contracts';
import { apiClient } from './apiClient';
import { noticeFromWire, normalizeMoney } from './wireAdapters';

/** E20 — GET /dashboard/stats (role-scoped nulls for L1/L2) */
export async function getDashboardStats(): Promise<DashboardStatsDto> {
  const { data } = await apiClient.get<DashboardStatsDto>('/dashboard/stats');
  const stats = normalizeMoney(data);
  return {
    ...stats,
    recentPayments: Array.isArray(stats?.recentPayments) ? stats.recentPayments : [],
    latestNotice: stats?.latestNotice
      ? noticeFromWire(stats.latestNotice as unknown as Record<string, unknown>)
      : null,
  };
}
